<template>
  <div class="progressBar">
    <div id="bar" class="innerbar" :style="percentageString"></div>
    <div class="flex-row progress-number">
      {{ this.nowSheetNumber }} &#47;
      {{ this.numberOfSheets + ' ' + $t('SAAI.WordSetting.ProgressBar.question') }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProgressBar',
  data() {
    return {
      percentageString: 'width:50%',
    };
  },
  methods: {
    setPercentage(nowSheetNumber, numberOfSheets) {
      let progressPercentage = (nowSheetNumber / numberOfSheets) * 100;
      this.percentageString = 'width:' + String(progressPercentage) + '%';
    },
  },
  computed: {
    ...mapState('saaiPaper', {
      nowSheetNumber: (state) => state.nowSheetNumber + 1,
      numberOfSheets: (state) => state.numberOfSheets,
    }),
  },
  watch: {
    nowSheetNumber() {
      this.setPercentage(this.nowSheetNumber, this.numberOfSheets);
    },
  },
  mounted() {
    this.setPercentage(this.nowSheetNumber, this.numberOfSheets);
  },
};
</script>

<style lang="scss">
.progressBar {
  max-width: 30%;
  width: 100%;
  height: 20px;
  border-radius: 3px;
  background: linear-gradient(#6fa6d66c, #7db1df54);
}

.innerbar {
  height: 100%;
  text-align: right;
  height: 20px;
  border-radius: 3px;
  background: $MAIN_COLOR;
}

.progress-number {
  font-weight: bold;
  font-size: large;
  justify-content: center;
  margin-top: 5px;
}
</style>
